import script from "./SettingsShowInactiveToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsShowInactiveToggle.vue?vue&type=script&setup=true&lang=js"

import "./SettingsShowInactiveToggle.vue?vue&type=style&index=0&id=568670f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-568670f6"]])

export default __exports__